var _classCallCheck = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var isEmpty = require('lodash.isempty');

var CloudWatchEventFormatter =
/*#__PURE__*/
function () {
  "use strict";

  function CloudWatchEventFormatter() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        formatLog = _ref.formatLog,
        formatLogItem = _ref.formatLogItem;

    _classCallCheck(this, CloudWatchEventFormatter);

    if (typeof formatLog === 'function') {
      this.formatLog = formatLog;
    } else if (typeof formatLogItem === 'function') {
      this.formatLogItem = formatLogItem;
    }
  }

  _createClass(CloudWatchEventFormatter, [{
    key: "formatLogItem",
    value: function formatLogItem(item) {
      return {
        message: this.formatLog(item),
        timestamp: item.date
      };
    }
  }, {
    key: "formatLog",
    value: function formatLog(item) {
      var meta = isEmpty(item.meta) ? '' : ' ' + JSON.stringify(item.meta, null, 2);
      return "[".concat(item.level.toUpperCase(), "] ").concat(item.message).concat(meta);
    }
  }]);

  return CloudWatchEventFormatter;
}();

module.exports = CloudWatchEventFormatter;